import index from "./views/index.vue";
import container from "./container.vue";
import login from "./views/login.vue";
import register from "./views/register.vue";
import otp from "./views/otp.vue";
import forgotPasswordTelp from "./views/forgotPasswordTelp";
import forgotPasswordOtp from "./views/forgotPasswordOtp";
import changePassword from "./views/changePassword";

const requireAuth = { requireAuth: false };
const router = [
  {
    path: "/",
    component: container,
    children: [
      {
        path: "",
        component: index,
        name: "index",
        meta: {
          ...requireAuth,
        },
      },
      {
        path: "login",
        component: login,
        name: "login",
        meta: {
          ...requireAuth,
        },
      },
      {
        path: "register",
        component: register,
        name: "Register",
        meta: {
          ...requireAuth,
        },
      },
      {
        path: "otp/:noTelp",
        component: otp,
        name: "otpVerif",
        meta: {
          ...requireAuth,
        },
      },
      {
        path: "forgotPasswordTelp",
        component: forgotPasswordTelp,
        name: "forgotPasswordTelp",
        meta: {
          ...requireAuth,
        },
      },
      {
        path: "forgotPasswordOtp/:noTelp",
        component: forgotPasswordOtp,
        name: "forgotPasswordOtp",
        meta: {
          ...requireAuth,
        },
      },
      {
        path: "changePassword/:noTelp",
        component: changePassword,
        name: "changePassword",
        meta: {
          ...requireAuth,
        },
      },
    ],
  },
];

export default router;
